import type { UserPermission } from '@/plugins/userPermissionPlugin'
import type { AccessibleResourceName } from '@/types'
import { computed, inject } from 'vue'

const injectUserPermission = (callerName: string) => {
  const permissions = inject<UserPermission>('userPermission')

  if (!permissions) {
    throw new Error(
      `${callerName} must be used within a component that provides userPermission`
    )
  }

  return permissions
}

export const useResourcePermissions = () => {
  const { canManage, canWrite, canRead } = injectUserPermission(
    'useResourcePermissions'
  )

  return {
    canManage,
    canWrite,
    canRead,
  }
}

export const useUserPermission = (resource: AccessibleResourceName) => {
  const permissions = injectUserPermission('useUserPermission')

  const canManage = computed(() => {
    return permissions.canManage(resource)
  })

  const canWrite = computed(() => {
    return permissions.canWrite(resource)
  })

  const canRead = computed(() => {
    return permissions.canRead(resource)
  })

  const canEditField = (field?: string) => {
    return permissions.canWrite(resource, field)
  }

  return {
    canManage,
    canWrite,
    canRead,
    canEditField,
  }
}
